/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-use-before-define */
import { Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { gameBookTemplateActions, gameVariablesTemplateActions } from '@orientaction/api-actions';
import { ContainerAdmin, MarginContainer } from '@orientaction/commons';
import { Layout } from '@orientaction/components';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ReactComponent as Check } from '../../../Asset/svg/check.svg';
import { apiServiceNative } from '../../../utils/fetchNative';
import { useStyles } from './style';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import { gameBookValues, gameVariables, gameVariableValues } from '@orientaction/reducers';
import { cloneDeep } from 'lodash';
import { PageRestitution } from '@orientaction/types';  

interface Item {
  id: number;
  name: string;
  description: string;
}

interface Props {
  data?: Item[];
}

type NewPageRestitution = PageRestitution & {
  isNew: boolean;
};

const SelecteTemplate: React.FC<Props> = () => {
  const history = useHistory();
  const classes = useStyles();
  const [selectedItemId, setSelectedItemId] = useState<number | null>(null);
  const [dataTemplate, setData] = useState<any>(null);
  const { id, edit }: any = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const handleClick = (itemId: number) => {
    setSelectedItemId(itemId === selectedItemId ? null : itemId);
  };
  const valuesBooksTemplate = useSelector(gameBookValues);
  const allVariables = useSelector(gameVariables);
  const valuesVariables = useSelector(gameVariableValues);

  const handleClickData = async (e: any) => {
    if (!selectedItemId) {
      console.log('No selected item ID provided, exiting function.');
      return;
    }
    const indexVariable = parseInt(sessionStorage.getItem('addRestitutionPagePosition') || '0', 10);
    const generateId = () => Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
    const newPageRestitution: NewPageRestitution = {
      template_game: selectedItemId,
      name: '',
      title: '',
      p1: '',
      p2: '',
      citationContent1: '',
      citationAuthor1: '',
      citationContent2: '',
      citationAuthor2: '',
      informationEncyclopedia1: '',
      informationEncyclopedia2: '',
      contentForType1: 'normal',
      contentForType2: 'normal',
      pEncyclopedia1: '',
      pEncyclopedia2: '',
      illustration: null,
      video: '',
      isNew: true,
      id: generateId() as unknown as number,
    };
    const allPageRestitution = cloneDeep([...valuesVariables.page_restitution]);
    allPageRestitution.splice(indexVariable, 0, newPageRestitution);
    dispatch(gameVariablesTemplateActions.setPageRestitution(allPageRestitution));
    confirmCancel();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataTemplateApi = await apiServiceNative.get(
          '/api/template-games?populate=*&sort=id:asc',
        );
        setData(dataTemplateApi?.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);
  if (dataTemplate?.length === 0) {
    return <div>Aucune donnée disponible</div>;
  }

  const goBack = () => {
    if (!edit) {
      history.push('/admin/game/create-variables');
    } else {
      history.push(`/admin/game/edit-variable/${id}/edit`);
    }
  };

  const confirmCancel = () => {
    if (!edit) {
      history.push(`/admin/game/edit-variable/${id}`);
    } else {
      history.push(`/admin/game/edit-variable/${id}/edit`);
    }
  };

  return (
    <Layout isaddBackground={true}>
      <ContainerAdmin>
        <MarginContainer big={true}>
          <div style={{ position: 'relative' }}>
            <div className={classes.btnFloat} onClick={goBack}>
              <KeyboardArrowLeftIcon />
              <div style={{ marginTop: '3px' }}>Retour</div>
            </div>
            <h1 className={classes.titleMain}>Sélection d'un modèle de restitution</h1>
          </div>
          <Grid component="ul" container={true} spacing={2} className={classes.list}>
            {dataTemplate &&
              dataTemplate.map((item: any) => (
                <Grid
                  item={true}
                  xs={6}
                  sm={4}
                  lg={3}
                  component="li"
                  key={item.id}
                  style={{ position: 'relative' }}
                  onClick={() => handleClick(item.id)}
                >
                  <span
                    className={`${classes.containerImg} ${
                      item.id === selectedItemId ? classes.selectedItem : ''
                    }`}
                  >
                    <img
                      src={item?.attributes?.img?.data[0]?.attributes?.url}
                      alt={item?.attributes?.name}
                      width="100%"
                      style={{ display: 'block' }}
                    />
                  </span>
                  <h3 className={classes.titleItem}>{item?.attributes?.name}</h3>
                  {item.id === selectedItemId && (
                    <span className={classes.check}>
                      <Check />
                    </span>
                  )}
                </Grid>
              ))}
          </Grid>
        </MarginContainer>{' '}
        {dataTemplate && (
          <Button
            variant="contained"
            color="primary"
            disabled={!selectedItemId}
            className={classes.btn}
            style={{ textTransform: 'none' }}
            onClick={(e: any) => handleClickData(e)}
          >
            Valider
          </Button>
        )}
      </ContainerAdmin>
    </Layout>
  );
};

export default SelecteTemplate;
